import { ReactNode } from "react";

export interface ModalProps {
  title: string;
  children: ReactNode;
  buttons?: ReactNode;
  closeButton: boolean;
  onClose: () => void;
}

export const Modal = ({
  title,
  children,
  buttons,
  closeButton,
  onClose,
}: ModalProps) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-10"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="flex h-[min(45rem,calc(100vh-5rem))] w-full max-w-[1472px] flex-col overflow-hidden rounded-3xl bg-white">
        <header className="flex items-center justify-between border-b border-gray-400 px-10 py-6">
          <h4 className="text-2xl font-bold tracking-tight">{title}</h4>

          <div className="flex flex-row items-center gap-3">
            {buttons}
            {closeButton && (
              <button
                type="button"
                className="cursor-pointer border-none bg-none p-1 text-2xl leading-none text-gray-400 hover:text-gray-900"
                onClick={onClose}
              >
                ×
              </button>
            )}
          </div>
        </header>

        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-[200px] py-[60px]">
          {children}
        </div>
      </div>
    </div>
  );
};
